import type {
  CommitmentInternalTransferReceiverVersion,
  CommitmentInternalTransferSenderVersion,
} from '@festina/life-general-types/life'
import { assertNotEmpty } from '@festina-life/core'

export const aggregateDataPerClaimReceiver = (
  commitmentInternalTransferSenderVersions: CommitmentInternalTransferSenderVersion[],
): CommitmentInternalTransferSenderVersion[] => {
  const deepClone = structuredClone(commitmentInternalTransferSenderVersions)

  return deepClone.reduce(
    (
      accumulator: CommitmentInternalTransferSenderVersion[],
      currentObject: CommitmentInternalTransferSenderVersion,
    ) => {
      const existingItem = accumulator.find(
        (item) =>
          item.receiverId === currentObject.receiverId &&
          item.toPolicyTemplateId === currentObject.toPolicyTemplateId,
      )

      assertNotEmpty(currentObject.toCoverTemplateId)

      if (existingItem) {
        if (
          !existingItem.toCoverTemplateId?.includes(
            currentObject.toCoverTemplateId,
          )
        ) {
          existingItem.toCoverTemplateId += `, ${currentObject.toCoverTemplateId}`
        }
        existingItem.benefit =
          (existingItem.benefit ?? 0) + (currentObject.benefit ?? 0)
      } else {
        accumulator.push(currentObject)
      }

      return accumulator
    },
    [],
  )
}

export const aggregateDataPerClaimSender = (
  commitmentInternalTransferReceiverVersion: CommitmentInternalTransferReceiverVersion[],
): CommitmentInternalTransferReceiverVersion[] => {
  const deepClone = structuredClone(commitmentInternalTransferReceiverVersion)

  return deepClone.reduce(
    (
      accumulator: CommitmentInternalTransferReceiverVersion[],
      currentObject: CommitmentInternalTransferReceiverVersion,
    ) => {
      const existingItem = accumulator.find(
        (item) => item.fromPolicyKey === currentObject.fromPolicyKey,
      )

      assertNotEmpty(currentObject.fromCoverKey)

      if (existingItem) {
        if (!existingItem.fromCoverKey?.includes(currentObject.fromCoverKey)) {
          existingItem.fromCoverKey += `, ${currentObject.fromCoverKey}`
        }
        existingItem.benefit =
          (existingItem.benefit ?? 0) + (currentObject.benefit ?? 0)
      } else {
        accumulator.push(currentObject)
      }

      return accumulator
    },
    [],
  )
}
